import { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
} from "../ui/dialog";

const FlyerModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const hasSeenModal = localStorage.getItem("ziwatech_flyer_modal_seen");
    if (!hasSeenModal) {
      const timer = setTimeout(() => {
        setIsOpen(true);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    localStorage.setItem("ziwatech_flyer_modal_seen", "true");
  };

  const handleDontShowAgain = () => {
    localStorage.setItem("ziwatech_flyer_modal_seen", "true");
    setIsOpen(false);
  };

  return (
    <>
      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogContent className="sm:max-w-4xl max-h-[90vh] overflow-y-auto p-0 omnes-regular">
          <div className="relative">
            <button
              onClick={handleClose}
              className="absolute top-2 right-2 z-10 p-2 bg-white rounded-full shadow-md hover:bg-gray-100"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <div className="flex">
              <div className="w-full md:w-1/2 bg-white p-8 flex flex-col justify-center">
                <div className="flex items-center gap-3 min-w-0 mb-2">
                  <div className="flex flex-col">
                    <span className="text-xl sm:text-2xl md:text-3xl font-black text-slate-900 truncate omnes-black">
                      Ziwa Tech
                    </span>
                    <span className="text-slate-600 text-sm omnes-bold -mt-2">
                      Your Local Tech Partner
                    </span>
                  </div>
                </div>

                <div className="border-t-2 border-dashed border-primary my-6 opacity-50"></div>

                <div className="text-lg font-bold text-black mb-4">
                  Now helps you get:
                </div>

                <ul className="text-left text-base font-semibold text-gray-800 space-y-2">
                  <li className="list-none">✅ Official Bell mobile plans & phones</li>
                  <li className="list-none">✅ Bell home internet today!</li>
                </ul>

                <div className="border-t-2 border-dashed border-primary my-6 opacity-50"></div>

                <div className="text-sm text-gray-600 mb-4">
                  Through our partnership with <strong>Wireless Nerds</strong>, 
                  we bring you the exact same official <strong>Bell</strong> rates, 
                  but with the fast, friendly local service you already trust.
                </div>

                <div className="border-t-2 border-dashed border-primary my-6 opacity-50"></div>

                <h1 className="text-3xl sm:text-4xl md:text-5xl font-black leading-[1.05] tracking-tight mb-6">
                  Bell phone plans,<br />
                  <span className="text-sky-500">made simple.</span>
                </h1>

                <div className="bg-blue-50 rounded-lg p-4 mb-4">
                  <div className="text-lg font-bold text-black mb-2">💰 Free bill comparison</div>
                  <div className="text-lg font-bold text-black mb-2">🔧 Expert setup while you wait</div>
                </div>

                <div className="border-t-2 border-dashed border-primary my-6 opacity-50"></div>

                <a 
                  href="https://wirelessnerds.ca/ziwa-tech"
                  className="px-4 py-2 rounded-xl font-black text-base md:text-lg bg-sky-500 hover:bg-sky-600 text-white shadow-lg shadow-sky-500/20 transition-all w-fit"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  See Today's Bell Deals →
                </a>

                <div className="text-2xl font-bold text-black mb-2">📞 647-200-2040</div>

                <div className="text-base font-semibold text-black">
                  📞 <a href="https://wa.me/16472002040" className="text-black hover:underline" target="_blank" rel="noopener noreferrer">Call/WhatsApp: wa.me/16472002040</a>
                </div>

                <div className="border-t-2 border-gray-200 my-6 pt-4"></div>

                <div className="text-xs font-semibold text-primary border-t-2 border-gray-200 pt-4">
                  <span className="bg-sky-500 text-white px-4 py-1 rounded-full text-xs font-bold inline-block mb-2">
                    Ziwa Tech At YorkgateMall
                  </span>
                  <br />
                  <span className="text-sky-500">Local Service You Can Trust</span>
                </div>
              </div>
              <div className="hidden md:block w-1/2 flex justify-center items-start pt-8">
                <img src="/images/bell.png" alt="Bell Logo" className="h-17 w-17 object-contain bg-gray-50 shadow-lg rounded-lg" />
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default FlyerModal;